import styled from 'styled-components';

export const ModalGeneral = styled.div`
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 3000;
  height: 100vh;
  width: 100%;
  left: 0;
  top: 0;
`;

export const ModalContent = styled.div`
  position: relative;
  margin: 0 auto;
  overflow: auto;
  width: 100vw;
  height: 100vh;
  padding: 2rem calc((100vw - 1000px) / 3);
  box-shadow: var(--box-shadow);
  @media (max-width: 1000px) {
    padding: 0;
  }
`;

export const ModalButtonContent = styled.div`
  position: relative;
  margin-top: 4.5rem;
  @media (max-width: 1000px) {
    margin-top: 0;
    padding: 0;
  }
  animation: animacao 0.5s ease forwards;
  @keyframes animacao {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`;

export const ModalClose = styled.div`
  color: #fff;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  background: #f00;
  font-size: 4rem;
  font-family: 'GothamBold';
  position: absolute;
  top: -15px;
  right: -15px;
  justify-content: center;
  align-items: center;
  display: flex;
  @media (max-width: 1030px) {
    top: 0;
    right: 0;
  }
  &:hover,
  &:focus {
    color: #f0f0f0;
    text-decoration: none;
    cursor: pointer;
  }
`;
